export enum CopType {
	CUBE_CAMERA = 'cubeCamera',
	VIDEO = 'video',
	WEB_CAM = 'webCam',
	SNAPSHOT = 'snapshot',
}
